/* eslint-disable */

export const protobufPackage = "od_protos.journey.data.categories";

export interface LanguageCategory {
  event?: { $case: "selectEvent"; selectEvent: LanguageCategory_SelectEvent } | undefined;
}

export enum LanguageCategory_Language {
  LANGUAGE_UNSPECIFIED = 0,
  ENGLISH = 1,
  SPANISH = 2,
  UNRECOGNIZED = -1,
}

export function languageCategory_LanguageFromJSON(object: any): LanguageCategory_Language {
  switch (object) {
    case 0:
    case "LANGUAGE_UNSPECIFIED":
      return LanguageCategory_Language.LANGUAGE_UNSPECIFIED;
    case 1:
    case "ENGLISH":
      return LanguageCategory_Language.ENGLISH;
    case 2:
    case "SPANISH":
      return LanguageCategory_Language.SPANISH;
    case -1:
    case "UNRECOGNIZED":
    default:
      return LanguageCategory_Language.UNRECOGNIZED;
  }
}

export function languageCategory_LanguageToJSON(object: LanguageCategory_Language): string {
  switch (object) {
    case LanguageCategory_Language.LANGUAGE_UNSPECIFIED:
      return "LANGUAGE_UNSPECIFIED";
    case LanguageCategory_Language.ENGLISH:
      return "ENGLISH";
    case LanguageCategory_Language.SPANISH:
      return "SPANISH";
    case LanguageCategory_Language.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface LanguageCategory_SelectEvent {
  language: LanguageCategory_Language;
}

function createBaseLanguageCategory(): LanguageCategory {
  return { event: undefined };
}

export const LanguageCategory = {
  fromJSON(object: any): LanguageCategory {
    return {
      event: isSet(object.selectEvent)
        ? { $case: "selectEvent", selectEvent: LanguageCategory_SelectEvent.fromJSON(object.selectEvent) }
        : undefined,
    };
  },

  toJSON(message: LanguageCategory): unknown {
    const obj: any = {};
    if (message.event?.$case === "selectEvent") {
      obj.selectEvent = LanguageCategory_SelectEvent.toJSON(message.event.selectEvent);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LanguageCategory>, I>>(base?: I): LanguageCategory {
    return LanguageCategory.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LanguageCategory>, I>>(object: I): LanguageCategory {
    const message = createBaseLanguageCategory();
    if (
      object.event?.$case === "selectEvent" &&
      object.event?.selectEvent !== undefined &&
      object.event?.selectEvent !== null
    ) {
      message.event = {
        $case: "selectEvent",
        selectEvent: LanguageCategory_SelectEvent.fromPartial(object.event.selectEvent),
      };
    }
    return message;
  },
};

function createBaseLanguageCategory_SelectEvent(): LanguageCategory_SelectEvent {
  return { language: 0 };
}

export const LanguageCategory_SelectEvent = {
  fromJSON(object: any): LanguageCategory_SelectEvent {
    return { language: isSet(object.language) ? languageCategory_LanguageFromJSON(object.language) : 0 };
  },

  toJSON(message: LanguageCategory_SelectEvent): unknown {
    const obj: any = {};
    if (message.language !== 0) {
      obj.language = languageCategory_LanguageToJSON(message.language);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LanguageCategory_SelectEvent>, I>>(base?: I): LanguageCategory_SelectEvent {
    return LanguageCategory_SelectEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LanguageCategory_SelectEvent>, I>>(object: I): LanguageCategory_SelectEvent {
    const message = createBaseLanguageCategory_SelectEvent();
    message.language = object.language ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string } ? { [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]> } & { $case: T["$case"] }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
